export default __webpack_public_path__ + "static/media/inter-semibold.89ece7ce.woff2";